@if ((render$ | async) && localesLoaded | async) {
  <form [formGroup]="form" class="flex-column" >
    @for (formField of this.attributeSelected.values; track formField) {
      <div  class="flex-100">
        @if (attributeSelected.metadata.type === 'TEXT') {
          <div>
            <mat-form-field appearance="fill"   class="form-field-width flex-align-center flex-100">
              @if (formField.country === 'US' && formField.language !== null) {
                <mat-label>English (United States)</mat-label>
              }
              @if (formField.country === 'US' && formField.language === null) {
                <mat-label>United States of America</mat-label>
              }
              @if (formField.country === 'CA' && formField.language !== null) {
                <mat-label>English (Canada)</mat-label>
              }
              @if (formField.country === 'CA' && formField.language === null) {
                <mat-label>Canada</mat-label>
              }
              @if (formField.country === 'PR' && (formField.language === 'en' || formField.language === '' || formField.language === undefined && formField.language !== null)) {
                <mat-label>English (Puerto Rico)</mat-label>
              }
              @if (formField.country === 'PR' && formField.language === 'es' && formField.language !== null) {
                <mat-label>Spanish (Puerto Rico)</mat-label>
              }
              @if (formField.country === 'PR' && formField.language === null) {
                <mat-label>Puerto Rico</mat-label>
              }
              <input matInput [formControlName]="formField.language + '-' + formField.country" [type]="'text'" class="flex-100"
                >
            </mat-form-field>
          </div>
        }
        @if (attributeSelected.metadata.type === 'TEXTAREA') {
          <div>
            <mat-form-field appearance="fill"   class="form-field-width flex-align-center flex-100">
              @if (formField.country === 'US' && formField.language !== null) {
                <mat-label>English (United States)</mat-label>
              }
              @if (formField.country === 'US' && formField.language === null) {
                <mat-label>United States of America</mat-label>
              }
              @if (formField.country === 'CA' && formField.language !== null) {
                <mat-label>English (Canada)</mat-label>
              }
              @if (formField.country === 'CA' && formField.language === null) {
                <mat-label>Canada</mat-label>
              }
              @if (formField.country === 'PR' && (formField.language === 'en' || formField.language === '' || formField.language === undefined && formField.language !== null)) {
                <mat-label>English (Puerto Rico)</mat-label>
              }
              @if (formField.country === 'PR' && formField.language === 'es' && formField.language !== null) {
                <mat-label>Spanish (Puerto Rico)</mat-label>
              }
              @if (formField.country === 'PR' && formField.language === null) {
                <mat-label>Puerto Rico</mat-label>
              }
              <input matInput [formControlName]="formField.language + '-' + formField.country" [type]="'text'" class="flex-100"
                >
            </mat-form-field>
          </div>
        }
        @if (attributeSelected.metadata.type === 'NUM') {
          <div>
            <mat-form-field appearance="fill"   class="form-field-width flex-align-center flex-100">
              @if (formField.country === 'US' && formField.language !== null) {
                <mat-label>English (United States)</mat-label>
              }
              @if (formField.country === 'US' && formField.language === null) {
                <mat-label>United States of America</mat-label>
              }
              @if (formField.country === 'CA' && formField.language !== null) {
                <mat-label>English (Canada)</mat-label>
              }
              @if (formField.country === 'CA' && formField.language === null) {
                <mat-label>Canada</mat-label>
              }
              @if (formField.country === 'PR' && (formField.language === 'en' || formField.language === '' || formField.language === undefined && formField.language !== null)) {
                <mat-label>English (Puerto Rico)</mat-label>
              }
              @if (formField.country === 'PR' && formField.language === 'es' && formField.language !== null) {
                <mat-label>Spanish (Puerto Rico)</mat-label>
              }
              @if (formField.country === 'PR' && formField.language === null) {
                <mat-label>Puerto Rico</mat-label>
              }
              <input matInput [formControlName]="formField.language + '-' + formField.country" [type]="'number'" class="flex-100"
                >
            </mat-form-field>
          </div>
        }
        @if (attributeSelected.metadata.type === 'BOOL') {
          <div>
            <mat-form-field appearance="fill"   class="form-field-width flex-align-center flex-100">
              @if (formField.country === 'US' && formField.language !== null) {
                <mat-label>English (United States)</mat-label>
              }
              @if (formField.country === 'US' && formField.language === null) {
                <mat-label>United States of America</mat-label>
              }
              @if (formField.country === 'CA' && formField.language !== null) {
                <mat-label>English (Canada)</mat-label>
              }
              @if (formField.country === 'CA' && formField.language === null) {
                <mat-label>Canada</mat-label>
              }
              @if (formField.country === 'PR' && (formField.language === 'en' || formField.language === '' || formField.language === undefined && formField.language !== null)) {
                <mat-label>English (Puerto Rico)</mat-label>
              }
              @if (formField.country === 'PR' && formField.language === 'es' && formField.language !== null) {
                <mat-label>Spanish (Puerto Rico)</mat-label>
              }
              @if (formField.country === 'PR' && formField.language === null) {
                <mat-label>Puerto Rico</mat-label>
              }
              <mat-select [formControlName]="formField.language + '-' + formField.country" class="flex-100" >
                @for (option of attributeSelected.metadata.options; track option) {
                  <mat-option
                  [value]="option.value">{{ option.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
        @if (attributeSelected.metadata.type === 'SELECT') {
          <div>
            <mat-form-field appearance="fill"   class="form-field-width flex-align-center flex-100">
              @if (formField.country === 'US' && formField.language !== null) {
                <mat-label>English (United States)</mat-label>
              }
              @if (formField.country === 'US' && formField.language === null) {
                <mat-label>United States of America</mat-label>
              }
              @if (formField.country === 'CA' && formField.language !== null) {
                <mat-label>English (Canada)</mat-label>
              }
              @if (formField.country === 'CA' && formField.language === null) {
                <mat-label>Canada</mat-label>
              }
              @if (formField.country === 'PR' && (formField.language === 'en' || formField.language === '' || formField.language === undefined && formField.language !== null)) {
                <mat-label>English (Puerto Rico)</mat-label>
              }
              @if (formField.country === 'PR' && formField.language === 'es' && formField.language !== null) {
                <mat-label>Spanish (Puerto Rico)</mat-label>
              }
              @if (formField.country === 'PR' && formField.language === null) {
                <mat-label>Puerto Rico</mat-label>
              }
              <mat-select [formControlName]="formField.language + '-' + formField.country" class="flex-100" >
                @for (option of attributeSelected.metadata.options; track option) {
                  <mat-option
                  [value]="option.value">{{ option.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
        @if (attributeSelected.metadata.type === 'MULTI_SELECT') {
          <div>
            <mat-form-field appearance="fill"   class="form-field-width flex-align-center flex-100">
              @if (formField.country === 'US' && formField.language !== null) {
                <mat-label>English (United States)</mat-label>
              }
              @if (formField.country === 'US' && formField.language === null) {
                <mat-label>United States of America</mat-label>
              }
              @if (formField.country === 'CA' && formField.language !== null) {
                <mat-label>English (Canada)</mat-label>
              }
              @if (formField.country === 'CA' && formField.language === null) {
                <mat-label>Canada</mat-label>
              }
              @if (formField.country === 'PR' && (formField.language === 'en' || formField.language === '' || formField.language === undefined && formField.language !== null)) {
                <mat-label>English (Puerto Rico)</mat-label>
              }
              @if (formField.country === 'PR' && formField.language === 'es' && formField.language !== null) {
                <mat-label>Spanish (Puerto Rico)</mat-label>
              }
              @if (formField.country === 'PR' && formField.language === null) {
                <mat-label>Puerto Rico</mat-label>
              }
              <mat-select [formControlName]="formField.language + '-' + formField.country"  multiple class="flex-100">
                <mat-option *ngFor="let option of attributeSelected.metadata.options as Array"
                [value]="option.value">{{ option.label }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        }
        @if (attributeSelected.metadata.type === 'IMAGE') {
          <div>
            <mat-form-field appearance="fill"   class="form-field-width flex-align-center flex-100">
              @if (formField.country === 'US' && formField.language !== null) {
                <mat-label>English (United States)</mat-label>
              }
              @if (formField.country === 'US' && formField.language === null) {
                <mat-label>United States of America</mat-label>
              }
              @if (formField.country === 'CA' && formField.language !== null) {
                <mat-label>English (Canada)</mat-label>
              }
              @if (formField.country === 'CA' && formField.language === null) {
                <mat-label>Canada</mat-label>
              }
              @if (formField.country === 'PR' && (formField.language === 'en' || formField.language === '' || formField.language === undefined && formField.language !== null)) {
                <mat-label>English (Puerto Rico)</mat-label>
              }
              @if (formField.country === 'PR' && formField.language === 'es' && formField.language !== null) {
                <mat-label>Spanish (Puerto Rico)</mat-label>
              }
              @if (formField.country === 'PR' && formField.language === null) {
                <mat-label>Puerto Rico</mat-label>
              }
              <input matInput [formControlName]="formField.language + '-' + formField.country" [type]="'text'" class="flex-100"
                >
            </mat-form-field>
          </div>
        }
      </div>
    }
  </form>
}
